import { UploadFile } from '../types/schema';
import transformUrl from './transformURL';

export const formatSrcSet = (
  url: string | UploadFile,
  type?: string,
  options?: { resize?: { [key: string]: string }; quality?: number },
) => {
  const xlargeImage = typeof url === 'string' ? url : url?.formats?.xlarge?.url || url?.url;
  const largeImage = typeof url === 'string' ? url : url?.formats?.large?.url || url?.url;
  const mediumImage = typeof url === 'string' ? url : url?.formats?.medium?.url || url?.url;
  const smallImage = typeof url === 'string' ? url : url?.formats?.small?.url || url?.url;
  const originalImage = typeof url === 'string' ? url : url?.url;

  // When URL is a plain string without Strapi formats and no fixed type/resize,
  // inject per-breakpoint width so Cloudinary resizes server-side
  const addWidth = typeof url === 'string' && !type && !options?.resize;
  const withWidth = (w: number) =>
    addWidth ? { ...options, resize: { type: 'scale', width: String(w) } } : options;

  return `${transformUrl(smallImage, type, withWidth(500))} 500w,
          ${transformUrl(mediumImage, type, withWidth(750))} 750w,
          ${transformUrl(largeImage, type, withWidth(1000))} 1000w,
          ${transformUrl(xlargeImage, type, withWidth(1400))} 1400w,
          ${transformUrl(originalImage, type, withWidth(2000))} 2000w`;
};
